import { refreshJobViewCount } from '../api/jobs.js';
import { initAppDownloadModal, initJobDetailVideo, initJobMenuModal } from './job-ui.js';

export const initJobCards = async () => {
  const jobCards = document.querySelectorAll('article.job-card');
  const jobDetailPanel = document.querySelector('section.job-detail-section');
  if (!jobDetailPanel) {
    return;
  }

  jobCards.forEach((card) => {
    card.addEventListener('click', async (event) => {
      const jobCard = event.currentTarget;
      const slug = jobCard.dataset.slug;

      const oldSelected = document.querySelector('article.job-card.selected');
      if (oldSelected) {
        oldSelected.classList.remove('selected');
      }

      jobCard.classList.add('selected');

      const html = await fetch(slug).then((response) => response.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('div.job-detail-page');
      if (!section) {
        return;
      }
      const jobId = section.getAttribute('data-job-id') || jobCard.dataset.jobId || '';

      jobDetailPanel.innerHTML = section.outerHTML;
      jobDetailPanel.scrollTo({ behavior: 'instant', left: 0, top: 0 });
      document.body.classList.add('is-job-detail-open');

      initJobDetailVideo();
      initJobMenuModal();
      initAppDownloadModal();

      const backButton = jobDetailPanel.querySelector('button.job-detail-back');
      if (backButton) {
        backButton.addEventListener('click', (e) => {
          e.preventDefault();
          jobDetailPanel.innerHTML = '';
          document.body.classList.remove('is-job-detail-open');
        });
      }

      const injectedDetailPage = jobDetailPanel.querySelector('div.job-detail-page');
      refreshJobViewCount({
        jobId,
        detailElement: injectedDetailPage,
        cardElement: jobCard,
      });
    });
  });

  if (
    window.matchMedia('(min-width: 1280px)').matches &&
    jobCards.length > 0
  ) {
    const hasSelected = document.querySelector('article.job-card.selected');
    const hasDetail = jobDetailPanel.querySelector('.job-detail-page');
    const hasSkeleton = jobDetailPanel.querySelector('.job-detail-skeleton');
    if (!hasSelected && (!hasDetail || hasSkeleton)) {
      const firstCard = jobCards[0];
      if (firstCard && firstCard.dataset.slug) {
        firstCard.click();
      }
    }
  }
};
